// eslint-disable-next-line no-restricted-imports -- This is the single allowed wrapper around useFormik
import { FormikConfig, FormikValues, useFormik } from "formik";

import { useDirtyForm } from "./dirty-form/useDirtyForm";

/** Re-export for forms that intentionally don't need dirty form tracking (e.g. search/filter forms). */
export { useFormik as useFormikWithoutDirtyForm };

/**
 * Wrapper around useFormik that automatically registers the form's dirty state
 * with the global DirtyFormContext. This ensures navigation blocking is always
 * wired up when a form has unsaved changes.
 *
 * Use this instead of useFormik directly.
 */
export function useFormikWithDirtyForm<Values extends FormikValues = FormikValues>(config: FormikConfig<Values>) {
  const formik = useFormik<Values>(config);

  useDirtyForm(formik.dirty);

  return formik;
}
